import { useParams } from 'react-router-dom';
import { PDPFormTill2025 } from './PDPFormTill2025';
import { PDPForm2026Plus } from './PDPForm2026Plus';

const PDPForm = () => {
  const { year } = useParams<{ year: string }>();
  const yearNumber = Number.parseInt(year);
  const is2024To2025 = yearNumber >= 2024 && yearNumber < 2026;
  const is2026Plus = yearNumber >= 2026;
  return (
    <>
      {is2024To2025 && <PDPFormTill2025 />}
      {is2026Plus && <PDPForm2026Plus />}
    </>
  );
};
export { PDPForm };
